<template>
  <div class="policy">

    <div class="hero-block__wrap">
      <h1 class="hero-block__title">Area Legale</h1>
    </div>

    <div class="istit__content">
      <div class="istit__content__inner">

        <h2>Privacy Policy</h2>

        <p><strong>Documento informativo articolo 13 Reg. UE 2016/679 GDPR Informativa per trattamento di dati personali raccolti presso l’interessato.</strong>.</p>

        <p>Nel rispetto di quanto previsto dal Reg. UE 2016/679 (<a href="http://eur-lex.europa.eu/legal-content/IT/TXT/HTML/?uri=CELEX:32016R0679&from=IT">Regolamento Europeo per la protezione dei dati personali</a>) in questa pagina forniamo le informazioni in ordine al trattamento dei dati personali forniti. Con «dato personale» viene inteso qualsiasi informazione riguardante una persona fisica identificata o identificabile («interessato»); si considera identificabile la persona fisica che può essere identificata, direttamente o indirettamente, con particolare riferimento a criteri come il nome, dati relativi all’ubicazione, un identificativo online o a uno o più elementi caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale (C26, C27, C30 Reg. UE 2016/679).</p>

        <p><strong>SOGGETTI DEL TRATTAMENTO TITOLARE DEL TRATTAMENTO</strong><br />Ai sensi degli artt. 4 e 24 del Reg. UE 2016/679, il titolare del trattamento dei dati è:
Laboratorio Polo, via Verdi 32, Oderzo (TV)
Indirizzo email del Titolare: <a href="mailto:info@pololab.com">info@pololab.com</a>.</p>
        <p><strong>FINALITÀ E LICEITA’ DEL TRATTAMENTO</strong><br />I dati di natura personale forniti, saranno oggetto di trattamento nel rispetto delle condizioni di liceità ex art. 6 Reg. UE 2016/679 per le seguenti finalità:

A) Gestione trattamento dati inerente (art. 6 lett. b):
navigazione sul presente sito web;
modulo contatti: i dati personali conferiti dall’utente in fase di compilazione modulo contatti, verranno trattati esclusivamente per le finalità connesse alla richiesta di informazioni inoltrata;
adempimento obblighi contrattuali, di legge e finalità amministrativo-contabile. Ai fini dell'applicazione delle disposizioni in materia di protezione dei dati personali, i trattamenti effettuati per finalità amministrativo-contabili sono quelli connessi allo svolgimento delle attività di natura organizzativa, amministrativa, finanziaria e contabile, a prescindere dalla natura dei dati trattati.
B) Gestione trattamento dati inerente (art.6 lett.a):
previo consenso e fino a Sua opposizione, i dati verranno trattati esclusivamente per finalità connesse alla richiesta di informazioni inoltrata e, in nessun caso, verranno ceduti, venduti o barattati.</p>
        <p><strong>PERIODO DI CONSERVAZIONE O CRITERI</strong><br />Il trattamento sarà svolto in forma automatizzata e/o manuale, con modalità e strumenti volti a garantire la massima sicurezza e riservatezza, ad opera di soggetti di ciò appositamente incaricati.

Nel rispetto di quanto previsto dall’art. 5 comma 1 lett. e) del Reg. UE 2016/679 i dati personali raccolti verranno conservati in una forma che consenta l’identificazione degli interessati per un arco di tempo non superiore al conseguimento delle finalità per le quali i dati personali sono trattati. La conservazione dei dati di natura personale forniti dipende dalla finalità del trattamento:

navigazione sul presente sito web (sessione);
per richiesta di contatto, preventivi e informazioni (massimo 12 mesi);
raccolta dati per selezione del personale (massimo 24 mesi);
adempimento obblighi contrattuali, di legge e finalità amministrativo-contabile (massimo 10 anni, salvo il maggior o minor termine stabilito dalla legge);
per ogni informazione sulla conservazione/gestione dei dati, l’interessato può scrivere a <a href="mailto:info@pololab.com">info@pololab.com</a>.</p>
        <p><strong>DIRITTI DEGLI INTERESSATI</strong><br />L’interessato potrà far valere i propri diritti come espressi dagli artt. 15, 16, 17, 18, 19, 20, 21, 22 del Regolamento UE 2016/679, rivolgendosi al Titolare del trattamento, scrivendo all’indirizzo <a href="mailto:info@pololab.com">info@pololab.com</a> o <a href="https://privacy.quamm.it/it/pololab">compilando il form</a>.

L’interessato ha il diritto, in qualunque momento, di chiedere al Titolare del trattamento l’accesso ai Suoi dati personali, la rettifica e la cancellazione degli stessi.</p>
        <p><strong>COOKIES</strong><br />Per maggiori informazioni sui cookies utilizzati dal presente sito web si veda la
        <router-link :to="{ name: 'cookie' }">cookies policy</router-link>.<br/>
        Questa informativa privacy riguarda esclusivamente il sito a dominio del titolare. Laboratorio Polo non è in alcun modo responsabile dei siti internet di terzi, anche se consultabili tramite links presenti in questo sito.</p>
      </div>
    </div>

    <global-footer />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import GlobalFooter from '../components/GlobalFooter'

export default {
  components: {
    GlobalFooter
  },
  data: () => ({
    logos: require('./Referenze/lista-loghi.json')
  }),
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

$marginLeftRight: 7.5%;
$marginLeftRightDesktop: 15%;
$marginBottom: 15%;

.policy {
  background: linear-gradient(0deg, #0487a3, #0b3277 70%);
  position: relative;
  box-sizing: border-box;
  .hero-block__wrap{
    position: relative;
    height: 60vh;
    padding-top: 6.25%;
    min-height: 400px;
    transform: none;
  }
}

.istit__content{

  @include media(">=large"){
    width: 85%;
  }
  @include media(">=xlarge"){
    width: 75%;
  }

}

.istit__content__inner{
  box-sizing: border-box;
  padding-left: $marginLeftRight;
  padding-right: $marginLeftRight;
  margin-bottom: 15rem;

  h2{
    margin-bottom: 6rem;
    font-size: 1.6rem;
    color: #f2f2f2;
    text-transform: uppercase;
    font-weight: 600;
  }
  p{
    font-size: 1.6rem;
    line-height: 2;
    color: #f2f2f2;
  }
  p + p{
    margin-top: 4rem;
    @include media(">=large"){
      margin-top: 3rem;
    }
  }
  p + h2{
    margin-top: 10rem;
    /*@include media(">=large"){
      margin-bottom: 18rem;
    }*/
  }
  strong{
    font-weight: 600;
  }
  @include media(">=large"){
    padding-left: $marginLeftRightDesktop;
    padding-right: $marginLeftRightDesktop;
  }
  @include media(">=xlarge"){
    p{
      font-size: 1.8rem;
    }
  }
}

</style>
